export default {
    current_choice: 'Escolha atual',
    book_now: 'Reservar agora',
    minimum_age: 'Apenas maiores de {age} anos',
    excess_liability: 'Responsabilidade por excesso',
    security_deposit: 'Depósito de segurança',
    fuel_policy: 'Política de combustível',
    like_for_like: 'Como por como',
    full_to_full: 'Cheio para cheio',
    miles_per_rental: '{mileage} milhas grátis por aluguel',
    km_per_rental: '{mileage} km grátis por aluguel',
    unlimited_mileage: 'Quilometragem ilimitada',
    unlimited_mileage_km: 'Km ilimitados',
    non_amendable: 'Não alterável',
    non_refundable: 'Não reembolsável',
    free_cancellation_until: 'Cancelamento gratuito até',
    basic_free_cancellation: 'Cancelamento gratuito até 48 horas antes da hora de início',
    cancellation_in_line_with: 'Cancelamento de acordo com',
    tcs: 'Termos e Condições',
    free_extras_on_collection: 'Dois extras gratuitos na retirada',
    glass_and_tyres_covered: 'Vidros e pneus cobertos',
    number_of_passengers: 'Número de passageiros',
    number_of_bags: 'Número de malas',
    fuel_type: 'Tipo de combustível',
    co2: 'CO2',
    aircon: 'Ar-condicionado',
    transmission: 'Transmissão',
    book_type: 'Reservar {type}',
    debit_card_deposit: 'Cartão de débito aceito para depósitos',
    fast_track_included: 'Atendimento rápido incluído',
    view_all: 'Ver tudo',
};
